(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('OrderBagSearch', OrderBagSearch);

    OrderBagSearch.$inject = ['$resource', 'ENV'];

    function OrderBagSearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/order-bags/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
